import { readSmartBlocks } from './read'

export const smartBlocks = {
  read: readSmartBlocks,
}
